import React from 'react';
import parse, {
  attributesToProps,
  Element,
  HTMLReactParserOptions,
  domToReact
} from 'html-react-parser';
import { sanitize } from 'dompurify';

import UserGeneratedLink from '@buyside/components/presentation/UserGeneratedLink/UserGeneratedLink';

import styles from '@buyside/components/presentation/ParsedHtml/parsedHtmlStyles.scss';

const htmlParserOptions: HTMLReactParserOptions = {
  replace: domNode => {
    if (domNode instanceof Element && domNode.name === 'img') {
      const props = attributesToProps(domNode.attribs);
      return <img {...props} alt="parsed image" />;
    } else if (domNode instanceof Element && domNode.name === 'table') {
      const props = attributesToProps(domNode.attribs);
      return (
        <>
          <div className={styles.tableNotViewable}>Table not viewable on mobile devices</div>
          <table {...props}>{domToReact(domNode.children, htmlParserOptions)}</table>
        </>
      );
    } else if (
      domNode instanceof Element &&
      domNode.name === 'a' &&
      domNode.attribs.href?.includes('http')
    ) {
      const props = attributesToProps(domNode.attribs);
      return (
        <UserGeneratedLink href={props.href}>
          {domToReact(domNode.children, htmlParserOptions)}
        </UserGeneratedLink>
      );
    }
    return;
  }
};

const ParsedHtml: React.FC<{
  html: string;
  children: (props: {
    content: string | JSX.Element | JSX.Element[];
    tinyMceStyles: string;
  }) => React.ReactNode;
}> = ({ html, children }) => (
  <div className={styles.parsedHtml}>
    {children &&
      children({
        content: parse(sanitize(html, { FORCE_BODY: true }), htmlParserOptions),
        tinyMceStyles: styles.tinymceContent
      })}
  </div>
);

export default ParsedHtml;
